export default __webpack_public_path__ + "static/media/gallery_13.b92406fa.jpg";